import SectionHead from "./SectionHead";

const MOMENTS = [
  {
    img: "https://readdy.ai/api/search-image?query=cinematic%20editorial%20scene%20of%20a%20detective%20evidence%20wall%20with%20printed%20photos%20connected%20by%20red%20thread%20and%20pins%2C%20warm%20cream%20and%20amber%20color%20palette%20with%20soft%20desk%20lamp%20glow%2C%20stylized%20illustration%2C%20mystery%20board%20aesthetic%2C%20high%20detail%2C%20no%20text&width=1000&height=700&seq=melon-m1-2026&orientation=landscape",
    no: "名场面 01",
    title: "红绳线索墙 · 网友逐帧考古",
    tag: "高潮",
  },
  {
    img: "https://readdy.ai/api/search-image?query=warm%20editorial%20illustration%20of%20a%20live%20streaming%20setup%20with%20ring%20light%20and%20microphone%20silhouette%20in%20front%20of%20a%20window%20at%20dusk%2C%20coral%20red%20and%20gold%20tones%2C%20soft%20bokeh%2C%20intimate%20honest%20atmosphere%2C%20stylized%20and%20artistic%2C%20no%20people%20faces%2C%20no%20text&width=1000&height=700&seq=melon-m2-2026&orientation=landscape",
    no: "名场面 02",
    title: "直播里的那句话",
    tag: "转折",
  },
  {
    img: "https://readdy.ai/api/search-image?query=empty%20movie%20theater%20screen%20showing%20warm%20glowing%20light%2C%20row%20of%20empty%20red%20velvet%20seats%2C%20coral%20and%20amber%20cinematic%20lighting%2C%20film%20premiere%20atmosphere%2C%20stylized%20editorial%20illustration%2C%20dramatic%20and%20warm%2C%20no%20text&width=1000&height=700&seq=melon-m3-2026&orientation=landscape",
    no: "名场面 03",
    title: "重剪版正式上线的瞬间",
    tag: "大结局",
  },
  {
    img: "https://readdy.ai/api/search-image?query=close%20up%20cinematic%20scene%20of%20a%20studio%20microphone%20under%20a%20single%20warm%20spotlight%20against%20dark%20amber%20background%2C%20particles%20of%20dust%20in%20the%20light%20beam%2C%20speaking%20moment%2C%20coral%20and%20gold%20palette%2C%20stylized%20artistic%2C%20no%20text&width=1000&height=700&seq=melon-m4-2026&orientation=landscape",
    no: "名场面 04",
    title: "主角发声 · 镜前独白",
    tag: "收尾",
  },
  {
    img: "https://readdy.ai/api/search-image?query=mysterious%20empty%20room%20with%20an%20open%20glowing%20door%20revealing%20warm%20light%2C%20shadows%20on%20the%20floor%2C%20amber%20and%20cream%20moody%20lighting%2C%20hint%20of%20new%20beginning%20and%20sequel%20foreshadowing%2C%20stylized%20editorial%20illustration%2C%20intriguing%20composition%2C%20no%20text&width=1000&height=700&seq=melon-m5-2026&orientation=landscape",
    no: "名场面 05",
    title: "片尾彩蛋 · 那扇空房间的门",
    tag: "伏笔",
  },
  {
    img: "https://readdy.ai/api/search-image?query=abstract%20editorial%20illustration%20of%20crowded%20online%20comment%20section%20with%20floating%20chat%20bubbles%2C%20hearts%20and%20fire%20icons%20on%20warm%20cream%20background%2C%20coral%20and%20amber%20accent%20colors%2C%20viral%20discussion%20energy%2C%20dynamic%20playful%20layout%2C%20no%20text&width=1000&height=700&seq=melon-m6-2026&orientation=landscape",
    no: "名场面 06",
    title: "讨论区一夜刷屏",
    tag: "热度",
  },
];

export default function Moments() {
  return (
    <section id="moments" className="scroll-mt-20 bg-background-50 py-14 md:py-20">
      <div className="page-shell">
        <SectionHead
          kicker="名场面 / 高光切片"
          title="那些反复被回味的瞬间"
          desc="一张图讲一个让讨论区炸开锅的瞬间。闭上眼回忆剧情，或直接下拉重温这几处高光。"
        />

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {MOMENTS.map((m) => (
            <figure
              key={m.no}
              className="group relative overflow-hidden rounded-2xl border border-background-200 bg-background-100"
            >
              <div className="relative aspect-[4/3] w-full overflow-hidden">
                <img
                  src={m.img}
                  alt={`${m.title}，${m.tag}阶段的 88吃瓜名场面`}
                  loading="lazy"
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="chip absolute left-3 top-3 bg-background-950/55 px-3 py-1 text-xs font-bold text-background-100 backdrop-blur-sm">
                  <i className="ri-fire-fill mr-1 text-accent-400" aria-hidden="true" />
                  {m.tag}
                </span>
              </div>
              <figcaption className="flex items-center justify-between gap-3 px-4 py-3.5">
                <div>
                  <div className="text-xs font-bold text-primary-500">{m.no}</div>
                  <h3 className="mt-0.5 text-sm font-black text-foreground-950 md:text-base">{m.title}</h3>
                </div>
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border border-background-300 text-foreground-600 transition-colors group-hover:bg-accent-500 group-hover:text-background-50 group-hover:border-accent-500">
                  <i className="ri-zoom-in-line" aria-hidden="true" />
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}